export default {
    formId: "PersonalForm",
    formField: {
        numProd: {
            name: 'numProd',
            label: 'Numero de Productor*',
        },
        names: {
            name: 'names',
            label: 'Nombre*',
            requiredErrorMsg: 'Por favor, ingrese su nombre'
        },
        lastName: {
            name: 'lastName',
            label: 'Apellido*',
            requiredErrorMsg: 'Por favor, ingrese su apellido'
        },
        codArea: {
            name: 'codArea',
            label: 'Código de Área*',
            requiredErrorMsg: 'Por favor, ingrese su código de área'
        },
        phone: {
            name: 'phone',
            label: 'Celular*',
            requiredErrorMsg: 'Por favor, ingrese su celular'
        },
        email: {
            name: 'email',
            label: 'Email*',
            requiredErrorMsg: 'Por favor, ingrese su email'
        },
        dni: {
            name: 'dni',
            label: 'DNI*',
            requiredErrorMsg: 'Por favor, ingrese su número de documento',
            invalidErrorMsg: 'DNI inválido'
        },
        cuit: {
            name: 'cuit',
            label: 'CUIT/CUIL*',
            requiredErrorMsg: 'Por favor, ingrese su número de CUIT/CUIL',
            invalidErrorMsg: 'CUIT/CUIL inválido'
        },
        address: {
            name: 'address',
            label: 'Dirección*',
            requiredErrorMsg: 'Por favor, ingrese su dirección',
        },
        sex: {
            name: 'sex',
            label: 'Sexo*',
            requiredErrorMsg: 'Por favor, ingrese su sexo',
        },

        codigosLocalidad: {
            name: 'codigosLocalidad',
            label: 'Código postal / Localidad',
            requiredErrorMsg: 'Debe especificar una localidad'
        },
    },
};
